import styled from 'styled-components';

export const Container = styled.div`
  align-self: center;
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  border-radius: 16px;

  label {
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }

    img {
      height: auto;
      width: 160px;
      border: 3px solid rgba(255, 255, 255, 0.3);
      background: #eee;
       border-radius: 16px;
    }

    input {
      display: none;
    }
  }
`;

export const DefaultAvatar = styled.div`
 border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 150px;
  border: 2px dashed #ddd;
  background: #fff;

  span {
    color: #ddd;
    font-size: 16px;
    font-weight: bold;
  }
`;
